import type { ReactElement } from "react";
import { useTranslation } from "react-i18next";
import type { WhatsappConnection } from "@/features/realtor/services/whatsapp-api.service";

const SYNC = "realtor.settings.whatsapp.sync";

/**
 * Meta's progress through the earlier-chats import, as a line of text over a
 * bar. Shown while the sync is pending or syncing.
 */
export function SyncProgressBar({
	syncState,
	historyProgress,
}: Pick<WhatsappConnection, "syncState" | "historyProgress">): ReactElement {
	const { t } = useTranslation();
	const progress = Math.max(0, Math.min(100, historyProgress));
	return (
		<div className="space-y-1.5">
			<p className="text-sm text-dashboard-text">
				{syncState === "pending"
					? t(`${SYNC}.pending`)
					: t(`${SYNC}.syncing`, { progress })}
			</p>
			<div
				role="progressbar"
				aria-label={t(`${SYNC}.progressLabel`)}
				aria-valuemin={0}
				aria-valuemax={100}
				aria-valuenow={progress}
				className="h-1.5 w-full overflow-hidden rounded-full bg-dashboard-progress-empty"
			>
				<div
					className="h-full rounded-full bg-dashboard-progress-complete"
					style={{ width: `${progress}%` }}
				/>
			</div>
		</div>
	);
}
